module.exports = __webpack_public_path__ + "img/mw.a2f03e32.svg";